.wrapper {
  display: flex;
  align-items: start;
  gap: 4px;
  font-size: 13px;
  font-weight: bold;

  &[data-variant='success'] {
    color: var(--color-text-success);
  }

  &[data-variant='warning'] {
    color: var(--color-text-warning);
  }

  &[data-variant='error'] {
    color: var(--color-text-error);
  }

  &[data-variant='info'] {
    color: var(--color-text-primary);
  }
}

.icon {
  width: 16px;
  height: 16px;
  margin-top: 1px;
}
